// extracted by mini-css-extract-plugin
export default {"container":"zJ-z","dimension":"AJ-z","dimensionLabels":"BJ-z"};